<template>
  <div id="about">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">About</div>
        </section-heading>
        <left-column :report="report"></left-column>
        <right-column :report="report"></right-column>
      </div>
    </div>
    <div class="sectionBreak row"></div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import LeftColumn from '@/components/reports/sections/about/LeftColumn';
import RightColumn from '@/components/reports/sections/about/RightColumn';

export default {
  components: {
    SectionHeading,
    LeftColumn,
    RightColumn,
  },
  props: ['report', 'showDiff', 'diffData'],
};
</script>
